"use client";
import React, { useEffect, useState } from "react";
import { Modal } from "@/app/(components)/Basic/Modal";
import { ShareSection } from "@/app/(components)/Basic/ShareSection";
import { Button } from "@/app/(components)/Basic/Button";
import { handleCopyText } from "@/shared/utilities";
import nftApi from "@/api/nfts/client";
import { useMutation } from "@tanstack/react-query";

export interface Props {
  isOpen: boolean;
  onClose: () => void;
  nftId: string;
}

function NftShareModal({ isOpen, onClose, nftId }: Props) {
  const [copyDisabled, setCopyDisabled] = useState(false);

  const { mutateAsync: setNftShared } = useMutation({
    mutationFn: (nftId: string) => nftApi.setNftShared(nftId),
  });

  useEffect(() => {
    if (isOpen) {
      setNftShared(nftId);
    }
  }, [isOpen, nftId, setNftShared]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} hasCloseButton>
      <div className="flex flex-col items-center  ">
        <h3 className="font-semibold tracking-tighter mb-6">Share artwork</h3>
        <span className="text-lg font-light text-center">
          If you like this NFT, share it with your friends
        </span>
        <ShareSection nftId={nftId} className="mt-15 mb-12" />
        <span className="text-lg font-light mb-4">or copy the share link</span>
        <Button
          onClick={() => handleCopyText(window.location.href, setCopyDisabled)}
          disabled={copyDisabled}
        >
          {copyDisabled ? "Copied" : "Copy link"}
        </Button>
      </div>
    </Modal>
  );
}

export default NftShareModal;
